import { Card, CardBody, Divider } from '@heroui/react';
import React from 'react';

import { type TabProps } from '../../types';

import { EmailNotifications, MessagingNotifications } from './components';

interface NotificationsTabProps extends TabProps {}

export const NotificationsTab: React.FC<NotificationsTabProps> = () => {
  // Notification fields are registered in the shared SupplierFormProvider
  // context — no separate FormProvider needed here.
  return (
    <Card>
      <CardBody className="p-6">
        <div className="flex flex-col gap-6">
          <div>
            <h2 className="text-xl font-semibold text-foreground mb-2">
              Notifications
            </h2>
            <p className="text-default-500">
              By inserting recipients into the fields below, the supplier will
              automatically start receiving orders via that particular channel.
            </p>
          </div>

          <EmailNotifications />

          <Divider className="my-2" />

          <MessagingNotifications />
        </div>
      </CardBody>
    </Card>
  );
};
